export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8061.c6f6afd7.jpg";